<template>
  <div class="box text-center">
    <div class="box-body form">
      <br />
      <div class="del-block" v-if="$route.params.tag_id">
        <div class="btn btn-danger" data-toggle="modal" data-target="#delModal"><i class="fa fa-trash"></i> </div>
      </div>
      <div><h3>餐點種類</h3></div>
    </div>
    <div class="box-body form">
      <div>
        <div class="input-group">
      <span class="input-group-addon">
        <span class="text-red">＊ </span>名稱
      </span>
          <input class="form-control" placeholder="" type="text" v-model="mealTagInfo.name" maxlength="45">
        </div>
      </div>
      <br />
      <div>
        <div class="input-group">
      <span class="input-group-addon">
        排序
      </span>
          <input class="form-control" placeholder="" v-model="mealTagInfo.sort" maxlength="99" type="tel" @keyup="veritySort" ref="sort">
        </div>
      </div>
      <span class="hidden-lg hidden-md"><br /></span>
    </div>
    <div class="box-body form">
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>顯示
        </span>
          <div class="form-group">
            <select class="form-control" v-model="mealTagInfo.is_visible">
              <option value="1">顯示</option>
              <option value="0">隱藏</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <!-- 圖示 -->
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>圖示
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!mealTagInfo.icon_file" class="text-black" v-text="'沒有圖片'" />
              <object style="width: 33px; height: 33px" type="image/svg+xml" :data="mealTagInfo.icon_file" v-else></object>

              <!-- <img :src="mealTagInfo.icon_file" class="h-auto img-responsive" v-if="mealTagInfo.icon_file" data-toggle="modal"> -->
            </span>
          </div>
          <div class="form-control h-100">
            <div>
              <label class="btn-upload btn btn-default m-t-25" style="margin-top: 8px;" for="meal-tag-icon-load">
                選擇圖片
              </label>
              <input class="form-control" type="file" style="display: none;" @change="onIconChange" id="meal-tag-icon-load">
            </div>
          </div>
        </div>
      </div>
      <div class="text-right text-15 text-red">(圖示為40x40~200x200)<br /></div>
      <!-- 底圖 -->
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            底圖
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!mealTagInfo.image_file" class="text-black" v-text="'沒有圖片'" />
              <img :src="mealTagInfo.image_file" class="h-auto img-responsive" v-if="mealTagInfo.image_file" data-toggle="modal">
            </span>
          </div>
          <div class="form-control h-100">
            <div>
              <label class="btn-upload btn btn-default m-t-25" style="margin-top: 8px;" for="meal-tag-img-load">
                選擇圖片
              </label>
              <input class="form-control" type="file" style="display: none;" @change="onImageChange" id="meal-tag-img-load">
            </div>
          </div>
        </div>
      </div>
      <div class="text-right text-15 text-red">(底圖大小為800x460)<br /></div>
    </div>

    <div class="box-footer text-center">
      <router-link to="/mealTagTable">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" v-if="!$route.params.tag_id" @click="checkBeforeSend('cr')">
        新增
      </button>
      <button class="btn btn-success" v-else @click="checkBeforeSend('up')">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>

<script>
import matcherModal from '../../../elements/Modal.vue'
import moment from 'moment'
import $ from 'jquery'
import ImgUploadTemp from './ImgUploadTemp.vue'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import VueTimepicker from 'vue2-timepicker'

export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      icon: {
        width: 0,
        height: 0
      },
      img: {
        width: 0,
        height: 0
      },
      mealTagInfo: {
        name: '',
        icon_file: '',
        image_file: '',
        sort: 1,
        is_visible: 1
      },
      delOption: {
        id: 'delModal',
        title: '刪除餐點種類',
        body: '確定刪除?<br>刪除此餐點種類！',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delMealTag'
          }
        ]
      }
    }
  },
  methods: {
    init () {
      if (this.$route.name === 'upMealTag') this.getMealTagInfo()
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.mealTagInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getMealTagInfo () {
      var self = this
      var url = '/mealTag/' + this.$route.params.tag_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const mealTagInfo = response.data.info
          self.mealTagInfo = {
            name: mealTagInfo.name,
            is_visible: mealTagInfo.is_visible,
            image_file: mealTagInfo.image,
            icon_file: mealTagInfo.icon,
            sort: mealTagInfo.sort
          }
        }
      })
    },
    onIconChange (e) {
      this.onFileChange(e, 'icon')
    },
    onImageChange (e) {
      this.onFileChange(e, 'img')
    },
    onFileChange (e, type) {
      this.imgLogoSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      let rule = /(jpg|jpeg|png)$/i
      if (type === 'icon') rule = /(jpg|jpeg|png|svg)$/i
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(rule)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.createImage(files[0], type)
      }
    },
    createImage (file, type) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (type === 'img') self.mealTagInfo.image_file = img.src
        else if (type === 'icon') self.mealTagInfo.icon_file = img.src
        img.onload = () => {
          if (type === 'img') {
            self.img.width = img.width
            self.img.height = img.height
            self.checkImgSize(type)
          } else if (type === 'icon') {
            self.icon.width = img.width
            self.icon.height = img.height
            console.log('icon_info', self.icon)
            self.checkImgSize(type)
          }
        }
      }
      reader.readAsDataURL(file)
    },
    checkImgSize (type) {
      let widthRule = 800
      let heightRule = 460
      let img = this.img
      if (type === 'img') {
        if ((img.width !== widthRule || img.height !== heightRule) && img.width !== 0 && img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '底圖尺寸為' + img.width + 'x' + img.height + '，請上傳' + widthRule + 'x' + heightRule + '之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        }
      } else if (type === 'icon') {
        widthRule = 40 // 最小
        heightRule = 200 // 最大
        img = this.icon
        console.log(this.icon)
        if ((img.width < widthRule || img.width > heightRule ||
          img.height < widthRule || img.height > heightRule) &&
          img.width !== 0 && img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '圖示為' + img.width + 'x' + img.height + '，請上傳' + widthRule + 'x' + widthRule + '~' + heightRule + 'x' + heightRule + '之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        }
      }
    },
    checkBeforeSend (type) {
      let all = this.getInput
      let msg = ''
      if (!all.name) {
        msg = '請輸入餐點種類名稱'
      } else if (!$('#meal-tag-icon-load')[0].files[0] && type === 'cr') {
        msg = '請上傳圖示'
      }
      this.getToast(msg, type)
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.createdMealTag()
        else if (type === 'up') this.updateMealTag()
      }
    },
    getBrandImgList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list
          for (var i = 0; i < logoList.length; i++) {
            var option = {name: logoList[i].image_name, value: logoList[i].image_url}
            self.imgLogoOption.push(option)
          }
        }
      })
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3'
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list
          for (var j = 0; j < bgList.length; j++) {
            var option2 = {name: bgList[j].image_name, value: bgList[j].image_url}
            self.imgBgOption.push(option2)
          }
        }
      })
    },
    createdMealTag () {
      var self = this
      var data = new FormData()
      var info = this.getInput
      var name = info.name
      var sort = info.sort
      data.append('name', name)
      data.append('is_visible', this.mealTagInfo.is_visible)
      if (sort) data.append('sort', parseInt(sort, 10))
      // console.log(startTime, endTime)
      // icon 圖片
      const iconFile = $('#meal-tag-icon-load')[0].files[0]
      const imgFile = $('#meal-tag-img-load')[0].files[0]
      if (iconFile) data.append('icon_file', iconFile)
      if (imgFile) data.append('image_file', imgFile)
      var url = '/mealTag'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.replace('/mealTagTable')
          }
        })
      }
    },
    updateMealTag () {
      var self = this
      var data = new FormData()
      var info = this.getInput
      var name = info.name
      var sort = info.sort
      data.append('name', name)
      data.append('is_visible', this.mealTagInfo.is_visible)
      if (sort) data.append('sort', parseInt(sort, 10))
      // icon 圖片
      const iconFile = $('#meal-tag-icon-load')[0].files[0]
      const imgFile = $('#meal-tag-img-load')[0].files[0]
      if (iconFile) data.append('icon_file', iconFile)
      if (imgFile) data.append('image_file', imgFile)
      var url = '/mealTag/' + this.$route.params.tag_id + '/syncInfo'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.replace('/mealTagTable')
          }
        })
      }
    },
    trigger (event) {
      if (event === 'delMealTag') {
        this.delMealTag()
      }
    },
    delMealTag () {
      var self = this
      var url = '/mealTag/' + this.$route.params.tag_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/mealTagTable')
        }
      })
    }
  },
  created () {
    this.init()
  },
  components: {
    'm-modal': matcherModal,
    'img-upload': ImgUploadTemp,
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getInput () {
      var aInfo = this.mealTagInfo
      for (let key in aInfo) {
        if (!aInfo[key] && typeof aInfo[key] === 'object') aInfo[key] = ' '
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        sort: this.checkInput(aInfo.sort.toString())
      }
    }
  },
  watch: {
    'menuTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time
        }
      ]
      // this.setMenuStartTime(this.menuTime.start.time)
    },
    'menuTime.end.time' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'),
          to: this.menuTime.end.time
        }
      ]
      // this.setMenuEndTime(this.menuTime.end.time)
    }
  }
}
</script>
<style lang="sass" scoped>
@media screen and (min-width: 992px)
  .box-body.form-left
    left: 5%
    width: 40%
  .box-body.form-right
    left: 4%
    width: 40%
@media screen and (max-width: 991px)
  .box-body.form-left, .box-body.form-right
    padding-left: 0px
    padding-right: 0px
</style>
<style lang="sass">
@media screen and (max-width: 767px)
  .cr-ad.input-group.cr-schedule .cov-vue-date .cov-datepicker
    width: calc(100vw - 165px)
</style>



// WEBPACK FOOTER //
// MealTagFormTemp.vue?18d340ff